var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-with-banner', {
    attrs: {
      "showFooter": false,
      "isProgressDone": true,
      "fluid": true
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('m-header', {
          attrs: {
            "title": _vm.$t('common.nouns.vehicles'),
            "breadCrumbs": _vm.breadCrumbs,
            "chips": _vm.chips,
            "actions": _vm.actions
          },
          on: {
            "actionClicked": function actionClicked($event) {
              return $event.exec();
            }
          }
        }), _c('fleet-manager-tree-dialog', {
          ref: "dialog",
          on: {
            "confirm": _vm.debounceUpdateTable
          }
        }), _vm.fleetId ? _c('v-row', [_vm.loading ? _c('v-col', [_c('v-skeleton-loader', {
          attrs: {
            "type": "table"
          }
        })], 1) : _c('v-col', {
          attrs: {
            "cols": "12",
            "sm": "12"
          }
        }, [_c('paginated-table', {
          key: _vm.updateTableKey,
          attrs: {
            "store": _vm.store,
            "headers": _vm.headers,
            "baseQuery": {
              partnerId: _vm.partnerId,
              fleetId: _vm.fleetId
            },
            "predefinedFilter": _vm.predefinedFilter,
            "showSelect": false,
            "isDownloadAsDisplayed": true
          },
          on: {
            "click:row": _vm.openDetail
          },
          scopedSlots: _vm._u([{
            key: "item.timestamp.created",
            fn: function fn(_ref) {
              var item = _ref.item;
              return [_vm._v(" " + _vm._s(_vm._f("simpleDoubleDigitDate")(item.timestamp.created)) + " ")];
            }
          }, {
            key: "item.ownership",
            fn: function fn(_ref2) {
              var item = _ref2.item;
              return [_vm._v(" " + _vm._s(item.ownership ? _vm.$t("enums.VehicleOwnershipStatusEnum.".concat(item.ownership)) : "") + " ")];
            }
          }, {
            key: "item.state",
            fn: function fn(_ref3) {
              var item = _ref3.item;
              return [item.state ? _c('v-chip', {
                attrs: {
                  "small": "",
                  "color": _vm.getState(item).color,
                  "dark": ""
                }
              }, [_vm._v(" " + _vm._s(_vm.i18n["state"][item.state]) + " ")]) : _vm._e()];
            }
          }], null, false, 772752892)
        })], 1)], 1) : _c('v-row', [_c('v-col', [_c('error-card', {
          on: {
            "reload": function reload($event) {
              return _vm.$router.push({
                name: 'FleetHomeView'
              });
            }
          }
        })], 1)], 1)];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }